import AuthLogin from "./AuthLogin";
import { LoginProvider } from "./LoginProvider";
import { useRoutes, Navigate } from "react-router-dom";
import { Manage } from "./Manage";

function App() {
  return (
    <LoginProvider>
      {useRoutes([
        {
          path: "login",
          element: <AuthLogin />,
        },
        {
          path: "manage",
          element: <Manage />,
        },
      ])}
    </LoginProvider>
  );
}

export default App;
